const PRODUCT_ID = document?.querySelector('body').getAttribute('product-id');

if (PRODUCT_ID) {
  const ASSET_ID_BY_PRODUCT_ID = {
    //Active Products
    "8554559373479": "a2748d02-c6a5-481f-b623-f9d255afd71c", // Legacy Executive High-Back (900)
    "8554560422055": "d02d9d37-c045-499c-9ecb-50657c789592", // Palisades Conference Mid-Back
    "8554560749735": "a6942d81-cbe9-4744-ae06-53859f95fe32", // Palisades Conference Mesh-Back
    "8685763887271": "7b31449b-b2a2-480c-a74f-1650ed5f4c2a", //Lifestyles Mid-Back Chair (8694)
    "8685763854503": "10e28179-ed8d-49c8-b03e-5bfe17cadb79", // Lifestyles Mid-Back Chair - Basic (8694B)
    "8685531234471": "ebb6c742-bfb5-4187-bf0c-e35802edc3ac",  //2490 Ultimate Executive Chairs
    "8685732233383": "7268bb7e-69d8-4980-9ab6-e4bbac3399f4", // 2390 Ultimate Executive Chairs
    "8685754319015": "5a579945-f403-473c-a46f-4a439fbf9e78", //Model 180B Brezza Basic
    "8685754253479": "d1f37e23-4c16-4402-9824-5ff75f198547", //Model 180 Brezza Standart
    "8554560028839": "ce73eea8-dbd4-47b8-9a0d-dc91afe6a623", //Model 5694B Lifestyles Basic
    "8554559635623": "d8fad74b-5085-4c81-be48-eb65797e0136", //Model 5694 Lifestyles Standart
  }

  const MAP_TABLE_ID_BY_PRODUCT_ID = {
    //Active Products 
    "8685763887271": "d23360bc-1021-4df4-a259-8847214fe06e", //Lifestyles Mid-Back Chair (8694)
    "8685763854503": "d23360bc-1021-4df4-a259-8847214fe06e", // Lifestyles Mid-Back Chair - Basic (8694B)
    "8554559373479": "d8881934-7bc2-4290-afb2-e4dbe18f8346", //Legacy Executive High-Back Chair (900)
    "8554560422055": "96cacf14-b094-4098-acde-218a7119fcd6", // Palisades Conference Mid-Back (4610)
    "8554560749735": "96cacf14-b094-4098-acde-218a7119fcd6", // Palisades Conference Mesh-Back (4010)
    "8685531234471": "f441c37a-fd2a-42c5-b98e-3173d5889ca3", //2490 Ultimate Executive Chairs
    "8685732233383": "e2532550-5ed7-4c42-8461-550cc675b564",  // 2390 Ultimate Executive Chairs
    "8685754319015": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee", //Model 180B Brezza Basic
    "8685754253479": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee", //Model 180 Brezza Standart
    "8554560028839": "8926a362-445b-4262-a607-95150e0d1cf6", //Balance Mid-Back Chair - Basic (5694B)
    "8554559635623": "8926a362-445b-4262-a607-95150e0d1cf6", //Balance Mid-Back Chair (5694)
    // "8406252290226": "8926a362-445b-4262-a607-95150e0d1cf6",
    // "8406253633714": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee",
    // "8406256025778": "8b073661-5b5d-4ae3-a783-f3e717b8a02e",
    // "8406254780594": "df2e5714-780e-4518-adc1-8d13dea70f53",
    // "8406256615602": "df2e5714-780e-4518-adc1-8d13dea70f53",
    // "8406257336498": "d8881934-7bc2-4290-afb2-e4dbe18f8346",
    // "8406257598642": "d23360bc-1021-4df4-a259-8847214fe06e",
    // "8406257729714": "d23360bc-1021-4df4-a259-8847214fe06e",
    // "8406257762482": "96cacf14-b094-4098-acde-218a7119fcd6",
    // "8406257828018": "96cacf14-b094-4098-acde-218a7119fcd6",
    // "6071389225138": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee",
    // "8416383303858": "d23360bc-1021-4df4-a259-8847214fe06e",
    // "8415751471282": "f441c37a-fd2a-42c5-b98e-3173d5889ca3",
    // "8416621559986": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee",
    // "8416618545330": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee",
    // "8418445033650": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee",
    // "8418439987378": "7728a2d0-0bf5-4148-a1da-4cd2798b96ee"
  }


  window.assetId = ASSET_ID_BY_PRODUCT_ID[`${PRODUCT_ID}`];
  window.mapTableId = MAP_TABLE_ID_BY_PRODUCT_ID[`${PRODUCT_ID}`];
}


